export default __webpack_public_path__ + "static/media/kabeoshi.9514f109.png";